import { useRef } from 'react'
import { useScroll, useTransform } from 'framer-motion'

export const useScrollingOrnament = (
  slidesCount: number,
  viewportHeight: number,
  offset = 0,
  maxIndex = 0
) => {
  const ref = useRef<HTMLDivElement>(null)
  const headerHeight =
    document.querySelector('#root > header')?.clientHeight ?? 0
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', `start ${headerHeight}px`],
  })
  const slideNum = useTransform(
    scrollYProgress,
    input =>
      (-(Math.round(input * (slidesCount - 1)) + offset) % slidesCount) *
      viewportHeight
  )
  const clampedIndex = useTransform(slideNum, input =>
    maxIndex ? input % (maxIndex * viewportHeight) : input
  )

  return { ref, slideNum: clampedIndex }
}
